//  Configuration field names

const ACCOUNTING_SYSTEM = "accountingSystem";
const ACCOUNTING_IDENTIFIER_METHODS = "accountingIdentifierMethods";
const ACCOUNTING_IDENTIFIER_METHOD = "accountingIdentifierMethod";
const ACCOUNTING_IDENTIFIER_METHOD2 = "accountingIdentifierMethod2";
const ACCOUNT_NUMBER_LENGTH = "accountNumberLength";
const ALLOWED_IMPORT_TRIGGER = "allowedTrigger";
const ALLOWED_PRAP_TRIGGER = "allowedPRAPTrigger";
const AUTO_SETUP = "autoSetup";
const BANK_TRANSFER_DEBITOR_ACCOUNT = "bankTransferDebitorAccount";
const CREDENTIALS = "credentials";
const END_DATE = "endDate";
const EXTERNAL_UUID = "externalUUID";
const INVOICE_IMPORT = "invoiceImport";
const IMPORT_FILTER_RULES = "importFilterRules";
const IS_INVOICE_IMPORT = "isInvoiceImport";
const IS_SINGLE_IMPORT = "isSingleImport";
const PASSWORD = "password";
const PLATFORM_CLIENT_EXTERNAL_UUID = "platformClientExternalUUID";
const PLATFORM_CLIENT_UUID = "clientUUID";
const PLATFORM_CLIENT_NAME = "clientName";
const PLATFORM_CLIENT_ID = "clientId";
const SINGLE_IMPORT = "singleImport";
const START_DATE = "startDate";
const STATUS = "status";
const TEXT = "text";
const UNKNOWN_DEBITOR_ACCOUNT = "unknownDebitorAccount";
const USE_MOSS = "useMoss";
const URL = "url";
const USERNAME = "username";
const LAST_SUCCESSFUL_IMPORT = "lastSuccessfulImport";
const HAS_CONNECTED_AUTH_DATA = "hasConnectedAuthData";

// accounting System Rules

const SKR_03 = "SKR_03";
const SKR_04 = "SKR_04";

export const ConfigurationFieldNames = {
    ACCOUNTING_SYSTEM,
    ACCOUNT_NUMBER_LENGTH,
    ACCOUNTING_IDENTIFIER_METHODS,
    ACCOUNTING_IDENTIFIER_METHOD,
    ACCOUNTING_IDENTIFIER_METHOD2,
    ALLOWED_IMPORT_TRIGGER,
    ALLOWED_PRAP_TRIGGER,
    AUTO_SETUP,
    BANK_TRANSFER_DEBITOR_ACCOUNT,
    CREDENTIALS,
    END_DATE,
    EXTERNAL_UUID,
    HAS_CONNECTED_AUTH_DATA,
    IMPORT_FILTER_RULES,
    INVOICE_IMPORT,
    IS_INVOICE_IMPORT,
    IS_SINGLE_IMPORT,
    LAST_SUCCESSFUL_IMPORT,
    PASSWORD,
    PLATFORM_CLIENT_EXTERNAL_UUID,
    PLATFORM_CLIENT_NAME,
    PLATFORM_CLIENT_UUID,
    PLATFORM_CLIENT_ID,
    SINGLE_IMPORT,
    START_DATE,
    STATUS,
    TEXT,
    USE_MOSS,
    UNKNOWN_DEBITOR_ACCOUNT,
    URL,
    USERNAME,
};

export const ConfigurationAccountingRules = {
    SKR_03,
    SKR_04,
};
